import React from 'react';

import { HistoryIcon } from '@assets/icon';
import { PermissionEnum } from '@modules/permissions/entity';
import { IRouter } from '@routers/interface';

const routerGiftDistributionHistory: IRouter = {
  path: '/gifts/gift-distribution-history',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'gift-distribution-history.router.name', //translate here for breadcrumb and sidebar
  masterLayout: true,
  icon: <HistoryIcon />,
  permissionCode: PermissionEnum.RewardRedemptionsView,
};

export default routerGiftDistributionHistory;
